import "../scss/app.scss"; // Importing SCSS file
import { ExpertGrid } from "./ExpertGrid";
import { LocationGrid } from "./LocationGrid";
// Instantiate the class
const locationGridInstance = new LocationGrid();

let export_grid_items = [...document.querySelectorAll(".expert-grid-item ")];
let converted_grid_items = export_grid_items.map((item) => {
  const { location, specialty, name } = item.dataset;
  return {
    element: item,
    location,
    specialty,
    name,
  };
});

 

const expertGridInstance = new ExpertGrid(converted_grid_items);

 

 

document.addEventListener("DOMContentLoaded", function () {
  let no_search_available = document.querySelector("#no-search-available");
  let search_items_container = document.querySelector(
    "#search-items-container"
  );
  
  let search_item = document.querySelector(".search-item");

 
  let search_item_title = search_item.querySelector(".search-title");
  let text = search_item_title?.textContent;
  console.log({
    search_item,
    search_item_title,
    text,
    no_search_available,
  });
  
  if (text == undefined) {
    text = '';
  }
  
  if ( search_item && text !== "") {
    console.log('Search item found');
    
    no_search_available.style.display = "none";
    search_items_container.style.display = "block";
  } else {
    console.log('Search item  not found');
      
    no_search_available.style.display = "block";
    search_items_container.style.display = "none";
  }
});

 